import { render, staticRenderFns } from "./previewMobile.vue?vue&type=template&id=8895b5c6&scoped=true"
import script from "./previewMobile.vue?vue&type=script&lang=js"
export * from "./previewMobile.vue?vue&type=script&lang=js"
import style0 from "./previewMobile.vue?vue&type=style&index=0&id=8895b5c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8895b5c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8895b5c6')) {
      api.createRecord('8895b5c6', component.options)
    } else {
      api.reload('8895b5c6', component.options)
    }
    module.hot.accept("./previewMobile.vue?vue&type=template&id=8895b5c6&scoped=true", function () {
      api.rerender('8895b5c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainFrom/previewMobile.vue"
export default component.exports